import { SmthBanner } from "../../../shared/pages/opencallsPage/GetCompetitionItem/style";
import { useTranslation } from "react-i18next";
import { FC } from "react";
import { PopUpMenu } from "shared/pages/opencallsPage/GetCompetitionItem/PopUpMenu";
import { Colors, FlexBox, ResizedImage, useIsMobile, usePagination } from "@brg/ui";
import { useMemo, useCallback, useEffect, useState } from "react";
import { ProjectsSearchBar } from "../../../shared/components/projectsSearchBar/projectsSearchBar";

import {
  CompetitionAPI,
  Competition,
  API,
  Project,
  Endpoints,
  PageModel,
} from "@brg/api";
import { useParams } from "react-router-dom";
import useDocumentTitle from "shared/hooks/useDocumentTitle";
import { Outer } from "shared/pages/explore/styles";
import { bProfile, useAuth } from "@brg/auth";
import { SortingTypeIndex } from "shared/constants/sortingType";
import {
  ListOuter,
  ShortListLabel,
  WinnerDescription,
  WinnerGapContainer,
  WinnerPlace,
  WinnerProjectWrapper,
  WinnersBox,
  WinnerText,
} from "./styles";
import ProjectCardNew from "shared/components/projectCard/projectCardNew";
import { ItemType } from "shared/constants/itemType";
import { CompetitionShowMoreContent } from "../AllCompetitionsPage/styled";
import { ProjectsGridNew } from "shared/components/grids";
import { Pagination } from "shared/components/pagination";
import { computeProject } from "../../../shared/helpers/types/computed/ComputedProject";
import { useSelector } from "react-redux";
import { CurrentCompetitionSelector } from "shared/reducers/CurrentCompetitionSlice";
import { useController } from "react-hook-form";
import { useGetCompetitionNominations } from "shared/hooks/api/useGetCompetitionNominations";
import { NOMINATIONS_STATUSES, NominationWinners, STATUSES, WinnerT } from "_competition/const";
import useQueryState from "shared/hooks/useQueryState";
import { NominationName } from "./components/NominationName";

export const ShortListPage: FC<{
  openLikeTab?: boolean;
  externalId?: string;
  showPreShortList?: boolean;
  activeTabKey?: string;
}> = ({ openLikeTab, externalId }) => {
  const { t, i18n } = useTranslation();
  const { associatedProfile, token } = useAuth();
  const isMobile = useIsMobile();
  const { id = externalId } = useParams<{ id: string }>();
  const [sorting, setSorting] = useState(1);
  const [{ tab: queryTab }, setQueryParams] = useQueryState();

  useDocumentTitle(id, "competition");

  // const [competition, setCompetition] = useState<Competition>();
  const [winnerProjects, setWinnerProjects] = useState<
    WinnerT[]
  >([]);
  const [finalistsProjects, setFinalistsProjects] = useState<
    WinnerT[]
  >([]);
  const [nominatiosWinners, setNominationsWinners] = useState<
    NominationWinners[]
  >([]);

  const profile = token ? associatedProfile : undefined;
  const { competition } = useSelector(CurrentCompetitionSelector)
  const { nominations, isLoading: nominationsLoading } = useGetCompetitionNominations(
    competition?.competitionId ?? '', 
    !competition?.hasManyCompetitions,
    NOMINATIONS_STATUSES
  )

  const finalistsPagination = usePagination(finalistsProjects, 20);

  const hasManyCompetitions = competition?.hasManyCompetitions

  const isModer = useMemo(
    () => profile && bProfile.isModer(profile),
    [profile]
  );

  const filteredNominations = useMemo(() => {
    if (nominationsLoading) return []
    const filtered = nominations?.filter((n) => [STATUSES.Completed, STATUSES.Archived]?.includes(n?.status))
    return filtered?.sort((a,b) => {
      const aDate = new Date(a.endDate);
      const bDate = new Date(b.endDate);
      if (aDate > bDate) return 1;
      return -1
    })
  }, [nominations, nominationsLoading])

  const showProjects = useMemo(
    // @ts-ignore
    () => competition?.nominations[0]?.showShortList || isModer,
    [competition, isModer]
  );

  const sortWinners = useMemo(
    () =>
      winnerProjects?.sort((a, b) => {
        if (a?.position > b?.position) {
          return 1;
        }
        return -1;
      }),
    [winnerProjects]
  );

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
  }, []);

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        isCategoriesHidden={true}
        hideRightButtons
        hideLeftBar
        sorting={sorting}
        hideRightBar={true}
        onSortingChange={onSortingChange}
      />
    ),
    [onSortingChange, sorting]
  );

  const winnerIntroText = useMemo(
    //@ts-ignore
    () => competition && competition?.winnerText_Intro,
    [competition]
  );

  const winnerFinalText = useMemo(
    //@ts-ignore
    () => competition && competition?.winnerText_Final,
    [competition]
  );

  const [expanded, setExpanded] = useState(false);
  const [winnerExpanded, setWinnerExpanded] = useState(false);

  const handleDescriptionExpanded = () => {
    setExpanded((prev) => !prev);
  };
  const handleWinnerDescription = () => {
    setWinnerExpanded((prev) => !prev);
  };

  const ShowMore = (props: any) => (
    <CompetitionShowMoreContent {...props}>
      {props.children}
    </CompetitionShowMoreContent>
  );

  const apiCall = async (projectIds: string[]) => {
    return await API.request()
      .post()
      .endpoint(Endpoints.geograffee)
      .url(`api/project/GetProjectsList`)
      .body({
        projectIds,
        projectFilter: 1,
        isContextIgnored: true,
      })
      .send()
      .then((v) => v.json())
      .then((v) => API.toLang<PageModel<Project>>(v, i18n.language));
  };

  useEffect(() => {
    if (competition) {
      //@ts-ignore
      const winnersIds: srting[] = competition?.nominations[0]?.winnerPositions.map((x) => x.winnerId);
      const finalistsIds = competition?.nominations[0]?.finalistsID;

      if (finalistsIds && finalistsIds.length !== 0) {
        apiCall(finalistsIds).then((v) => {
          const arr = v.data.map((x) => {
            return { project: x, position: 0 };
          });
          setFinalistsProjects(arr);
        });
      }

      if (winnersIds && winnersIds.length !== 0) {
        apiCall(winnersIds).then((v) => {
          const arr = v.data.map((x) => {
            //@ts-ignore
            var temp = competition?.nominations[0]?.winnerPositions.find(
              (f: any) => f.winnerId === x.projectId
            );

            return { project: x, position: temp?.position ?? 1 };
          });

          setWinnerProjects(arr);
        });
      }
      if (filteredNominations?.length > 0) {
        Promise.all(filteredNominations?.map(({ 
          nominations, 
          competitionId, 
          name, 
          competitionColorTheme: { backgroundColor: color } 
        }) => {
          const ids = nominations?.[0]?.winnerPositions.map((x) => x.winnerId);

          if (ids?.length === 0) {
            return {
              id: competitionId ?? '', projects: [], name, color
            }
          }
          return apiCall(ids).then((v) => {
            const projects = (v?.data || [])
              ?.map((p) => {
                return {
                  project: {...p},
                  position: nominations?.[0]?.winnerPositions.find(
                    (f: any) => f.winnerId === p.projectId
                  )?.position ?? 1
                }
              })
              ?.sort((a,b) => {
                if (a.position > b?.position) return 1;
                return -1;
              })

            return { id: competitionId ?? '', projects, name, color };
          });
        }))
        .then((r) => {
          setNominationsWinners(r?.filter((c) => !!c?.projects?.length))
        })
      }
    }
  }, [competition, filteredNominations, i18n.language]);

  const calcGridColumn = useCallback(
    (winnerProject: any) => {

      return ['t-shape', 'fixed-ratio-small', 'fixed-ratio-large'].includes(winnerProject.project?.projectType) ? true : false;
    }, [])

    const winnersView = useMemo(() => {
      const winnersLayout = !!sortWinners?.length ? (
        <>
          {winnerIntroText && (
            <WinnerDescription offsetBottom={32} offsetBottomMobile={24}>
              <ShowMore
                importantStyles
                more={t("show_more_text")}
                less={t("show_less_text")}
                lines={5}
                expanded={expanded}
                onClick={handleDescriptionExpanded}
              >
                {<div dangerouslySetInnerHTML={{ __html: winnerIntroText }} />}
              </ShowMore>
            </WinnerDescription>
          )}
          <WinnersBox mobile={isMobile}>
            {sortWinners.map((winnerProject) => {
            return (
              <WinnerProjectWrapper isLargeProject={calcGridColumn(winnerProject)} key={winnerProject.project.projectId}>
                <WinnerPlace>
                  <WinnerText>{winnerProject.position}</WinnerText>
                  <WinnerText>{t("competition.short_list.place")}</WinnerText>
                </WinnerPlace>
                <ProjectCardNew
                  project={winnerProject.project}
                  {...computeProject(winnerProject.project)}
                  itemType={calcGridColumn(winnerProject) ? ItemType.competition : ItemType.book}
                  isModal={false}
                  withoutGoToProject={false}
                  isSelectable={false}
                />
              </WinnerProjectWrapper>
            );
          })}
          </WinnersBox>
          {winnerFinalText && (
          <WinnerDescription offsetTop={32} offsetTopMobile={24}>
            <ShowMore
              importantStyles
              more={t("show_more_text")}
              less={t("show_less_text")}
              lines={4}
              expanded={winnerExpanded}
              onClick={handleWinnerDescription}
            >
              {winnerFinalText}
            </ShowMore>
          </WinnerDescription>
        )}
        </>
      ) : null;

      return winnersLayout
    } , [sortWinners, winnerFinalText, winnerExpanded, winnerIntroText, isMobile])

    const finalistView = useMemo(() => {
      if (finalistsProjects?.length > 0 && showProjects) {
        return (
          <FlexBox
          direction="column"
          directionMobile="column"
          offsetTopMobile={19}
          id="shortlist-scroll-target"
        >
          <ShortListLabel>
            {['3ed8dd343f454c0a9052a92e57cac8f1', 'a049d4b8f2094fbb85b29ec11fa2f30d'].includes(competition?.competitionId ?? '')
              ? t("competition.short_list.public_vote")
              : t("competition.short_list.finalists")}
          </ShortListLabel>
          <ProjectsGridNew k={20} isLoading={false} itemType={ItemType.book}>
            {finalistsPagination.items?.map(
              (proj: { project: Project; position: Number }) => {
                return (
                  <ProjectCardNew
                    key={proj.project.projectId}
                    project={proj.project}
                    itemType={ItemType.book}
                    isModal={false}
                    withoutGoToProject={false}
                    {...computeProject(proj.project)}
                    isSelectable={false}
                  />
                );
              })}
          </ProjectsGridNew>
          <Pagination {...finalistsPagination} scrollTarget="#shortlist-scroll-target" />
        </FlexBox>
        )
      }
    } , [finalistsProjects, showProjects, finalistsPagination.page, finalistsPagination.items, t])

    const nominationsView = useMemo(() => {
      if (nominationsLoading) {
        return (
          <ProjectsGridNew k={8} isLoading={true} itemType={ItemType.book} />
        )
      }
      if (nominatiosWinners?.length > 0 && queryTab === 'results') {
        return (
          <WinnerGapContainer>
            {nominatiosWinners?.map(({ projects, name, color }, index) => {
          return (
            <WinnerGapContainer>
              <NominationName name={name} color={color ?? Colors.galBlack100}/>
              <WinnersBox mobile={isMobile}>
                {projects.map((winnerProject) => {
                  return (
                    <WinnerProjectWrapper isLargeProject={calcGridColumn(winnerProject)} key={winnerProject.project.projectId}>
                      <WinnerPlace>
                        <WinnerText>{winnerProject.position ?? 1}</WinnerText>
                        <WinnerText>{t("competition.short_list.place")}</WinnerText>
                      </WinnerPlace>
                      <ProjectCardNew
                        project={winnerProject.project}
                        {...computeProject(winnerProject.project)}
                        itemType={calcGridColumn(winnerProject) ? ItemType.competition : ItemType.book}
                        isModal={false}
                        withoutGoToProject={false}
                        isSelectable={false}
                      />
                    </WinnerProjectWrapper>
                  );
                })}
              </WinnersBox>
            </WinnerGapContainer>
          )
        })
      }
          </WinnerGapContainer>
        )}
  } , [nominatiosWinners, nominationsLoading, competition,hasManyCompetitions])

    return (
      <ListOuter style={{ marginTop: isMobile ? 0 : "24px", padding: 0 }}>
        <FlexBox align="center" offsetTopMobile={10}>
          {searchBar}
        </FlexBox>
        {nominationsView}
        {winnersView}
        {finalistView}
      </ListOuter>
    )
};
import { SmthBanner } from "../../../shared/pages/opencallsPage/GetCompetitionItem/style";
import { useTranslation } from "react-i18next";
import { FC } from "react";
import { PopUpMenu } from "shared/pages/opencallsPage/GetCompetitionItem/PopUpMenu";
import { Colors, FlexBox, ResizedImage, useIsMobile, usePagination } from "@brg/ui";
import { useMemo, useCallback, useEffect, useState } from "react";
import { ProjectsSearchBar } from "../../../shared/components/projectsSearchBar/projectsSearchBar";

import {
  CompetitionAPI,
  Competition,
  API,
  Project,
  Endpoints,
  PageModel,
} from "@brg/api";
import { useParams } from "react-router-dom";
import useDocumentTitle from "shared/hooks/useDocumentTitle";
import { Outer } from "shared/pages/explore/styles";
import { bProfile, useAuth } from "@brg/auth";
import { SortingTypeIndex } from "shared/constants/sortingType";
import {
  ListOuter,
  ShortListLabel,
  WinnerDescription,
  WinnerGapContainer,
  WinnerPlace,
  WinnerProjectWrapper,
  WinnersBox,
  WinnerText,
} from "./styles";
import ProjectCardNew from "shared/components/projectCard/projectCardNew";
import { ItemType } from "shared/constants/itemType";
import { CompetitionShowMoreContent } from "../AllCompetitionsPage/styled";
import { ProjectsGridNew } from "shared/components/grids";
import { Pagination } from "shared/components/pagination";
import { computeProject } from "../../../shared/helpers/types/computed/ComputedProject";
import { useSelector } from "react-redux";
import { CurrentCompetitionSelector } from "shared/reducers/CurrentCompetitionSlice";
import { useController } from "react-hook-form";
import { useGetCompetitionNominations } from "shared/hooks/api/useGetCompetitionNominations";
import { NOMINATIONS_STATUSES, NominationWinners, STATUSES, WinnerT } from "_competition/const";
import useQueryState from "shared/hooks/useQueryState";
import { NominationName } from "./components/NominationName";

export const ShortListPage: FC<{
  openLikeTab?: boolean;
  externalId?: string;
  showPreShortList?: boolean;
  activeTabKey?: string;
}> = ({ openLikeTab, externalId }) => {
  const { t, i18n } = useTranslation();
  const { associatedProfile, token } = useAuth();
  const isMobile = useIsMobile();
  const { id = externalId } = useParams<{ id: string }>();
  const [sorting, setSorting] = useState(1);
  const [{ tab: queryTab }, setQueryParams] = useQueryState();

  useDocumentTitle(id, "competition");

  // const [competition, setCompetition] = useState<Competition>();
  const [winnerProjects, setWinnerProjects] = useState<
    WinnerT[]
  >([]);
  const [finalistsProjects, setFinalistsProjects] = useState<
    WinnerT[]
  >([]);
  const [nominatiosWinners, setNominationsWinners] = useState<
    NominationWinners[]
  >([]);

  const profile = token ? associatedProfile : undefined;
  const { competition } = useSelector(CurrentCompetitionSelector)
  const { nominations, isLoading: nominationsLoading } = useGetCompetitionNominations(
    competition?.competitionId ?? '', 
    !competition?.hasManyCompetitions,
    NOMINATIONS_STATUSES
  )

  const finalistsPagination = usePagination(finalistsProjects, 20);

  const hasManyCompetitions = competition?.hasManyCompetitions

  const isModer = useMemo(
    () => profile && bProfile.isModer(profile),
    [profile]
  );

  const filteredNominations = useMemo(() => {
    if (nominationsLoading) return []
    const filtered = nominations?.filter((n) => [STATUSES.Completed, STATUSES.Archived]?.includes(n?.status))
    return filtered?.sort((a,b) => {
      const aDate = new Date(a.endDate);
      const bDate = new Date(b.endDate);
      if (aDate > bDate) return 1;
      return -1
    })
  }, [nominations, nominationsLoading])

  const showProjects = useMemo(
    // @ts-ignore
    () => competition?.nominations[0]?.showShortList || isModer,
    [competition, isModer]
  );

  const sortWinners = useMemo(
    () =>
      winnerProjects?.sort((a, b) => {
        if (a?.position > b?.position) {
          return 1;
        }
        return -1;
      }),
    [winnerProjects]
  );

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
  }, []);

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        isCategoriesHidden={true}
        hideRightButtons
        hideLeftBar
        sorting={sorting}
        hideRightBar={true}
        onSortingChange={onSortingChange}
      />
    ),
    [onSortingChange, sorting]
  );

  const winnerIntroText = useMemo(
    //@ts-ignore
    () => competition && competition?.winnerText_Intro,
    [competition]
  );

  const winnerFinalText = useMemo(
    //@ts-ignore
    () => competition && competition?.winnerText_Final,
    [competition]
  );

  const [expanded, setExpanded] = useState(false);
  const [winnerExpanded, setWinnerExpanded] = useState(false);

  const handleDescriptionExpanded = () => {
    setExpanded((prev) => !prev);
  };
  const handleWinnerDescription = () => {
    setWinnerExpanded((prev) => !prev);
  };

  const ShowMore = (props: any) => (
    <CompetitionShowMoreContent {...props}>
      {props.children}
    </CompetitionShowMoreContent>
  );

  const apiCall = async (projectIds: string[]) => {
    return await API.request()
      .post()
      .endpoint(Endpoints.geograffee)
      .url(`api/project/GetProjectsList`)
      .body({
        projectIds,
        projectFilter: 1,
        isContextIgnored: true,
      })
      .send()
      .then((v) => v.json())
      .then((v) => API.toLang<PageModel<Project>>(v, i18n.language));
  };

  useEffect(() => {
    if (competition) {
      //@ts-ignore
      const winnersIds: srting[] = competition?.nominations[0]?.winnerPositions.map((x) => x.winnerId);
      const finalistsIds = competition?.nominations[0]?.finalistsID;

      if (finalistsIds && finalistsIds.length !== 0) {
        apiCall(finalistsIds).then((v) => {
          const arr = v.data.map((x) => {
            return { project: x, position: 0 };
          });
          setFinalistsProjects(arr);
        });
      }

      if (winnersIds && winnersIds.length !== 0) {
        apiCall(winnersIds).then((v) => {
          const arr = v.data.map((x) => {
            //@ts-ignore
            var temp = competition?.nominations[0]?.winnerPositions.find(
              (f: any) => f.winnerId === x.projectId
            );

            return { project: x, position: temp?.position ?? 1 };
          });

          setWinnerProjects(arr);
        });
      }
      if (filteredNominations?.length > 0) {
        Promise.all(filteredNominations?.map(({ 
          nominations, 
          competitionId, 
          name, 
          competitionColorTheme: { backgroundColor: color } 
        }) => {
          const ids = nominations?.[0]?.winnerPositions.map((x) => x.winnerId);

          if (ids?.length === 0) {
            return {
              id: competitionId ?? '', projects: [], name, color
            }
          }
          return apiCall(ids).then((v) => {
            const projects = (v?.data || [])
              ?.map((p) => {
                return {
                  project: {...p},
                  position: nominations?.[0]?.winnerPositions.find(
                    (f: any) => f.winnerId === p.projectId
                  )?.position ?? 1
                }
              })
              ?.sort((a,b) => {
                if (a.position > b?.position) return 1;
                return -1;
              })

            return { id: competitionId ?? '', projects, name, color };
          });
        }))
        .then((r) => {
          setNominationsWinners(r?.filter((c) => !!c?.projects?.length))
        })
      }
    }
  }, [competition, filteredNominations, i18n.language]);

  const calcGridColumn = useCallback(
    (winnerProject: any) => {

      return ['t-shape', 'fixed-ratio-small', 'fixed-ratio-large'].includes(winnerProject.project?.projectType) ? true : false;
    }, [])

    const winnersView = useMemo(() => {
      const winnersLayout = !!sortWinners?.length ? (
        <>
          {winnerIntroText && (
            <WinnerDescription offsetBottom={32} offsetBottomMobile={24}>
              <ShowMore
                importantStyles
                more={t("show_more_text")}
                less={t("show_less_text")}
                lines={5}
                expanded={expanded}
                onClick={handleDescriptionExpanded}
              >
                {<div dangerouslySetInnerHTML={{ __html: winnerIntroText }} />}
              </ShowMore>
            </WinnerDescription>
          )}
          <WinnersBox mobile={isMobile}>
            {sortWinners.map((winnerProject) => {
            return (
              <WinnerProjectWrapper isLargeProject={calcGridColumn(winnerProject)} key={winnerProject.project.projectId}>
                <WinnerPlace>
                  <WinnerText>{winnerProject.position}</WinnerText>
                  <WinnerText>{t("competition.short_list.place")}</WinnerText>
                </WinnerPlace>
                <ProjectCardNew
                  project={winnerProject.project}
                  {...computeProject(winnerProject.project)}
                  itemType={calcGridColumn(winnerProject) ? ItemType.competition : ItemType.book}
                  isModal={false}
                  withoutGoToProject={false}
                  isSelectable={false}
                />
              </WinnerProjectWrapper>
            );
          })}
          </WinnersBox>
          {winnerFinalText && (
          <WinnerDescription offsetTop={32} offsetTopMobile={24}>
            <ShowMore
              importantStyles
              more={t("show_more_text")}
              less={t("show_less_text")}
              lines={4}
              expanded={winnerExpanded}
              onClick={handleWinnerDescription}
            >
              {winnerFinalText}
            </ShowMore>
          </WinnerDescription>
        )}
        </>
      ) : null;

      return winnersLayout
    } , [sortWinners, winnerFinalText, winnerExpanded, winnerIntroText, isMobile])

    const finalistView = useMemo(() => {
      if (finalistsProjects?.length > 0 && showProjects) {
        return (
          <FlexBox
          direction="column"
          directionMobile="column"
          offsetTopMobile={19}
          id="shortlist-scroll-target"
        >
          <ShortListLabel>
            {['3ed8dd343f454c0a9052a92e57cac8f1', 'a049d4b8f2094fbb85b29ec11fa2f30d'].includes(competition?.competitionId ?? '')
              ? t("competition.short_list.public_vote")
              : t("competition.short_list.finalists")}
          </ShortListLabel>
          <ProjectsGridNew k={20} isLoading={false} itemType={ItemType.book}>
            {finalistsPagination.items?.map(
              (proj: { project: Project; position: Number }) => {
                return (
                  <ProjectCardNew
                    key={proj.project.projectId}
                    project={proj.project}
                    itemType={ItemType.book}
                    isModal={false}
                    withoutGoToProject={false}
                    {...computeProject(proj.project)}
                    isSelectable={false}
                  />
                );
              })}
          </ProjectsGridNew>
          <Pagination {...finalistsPagination} scrollTarget="#shortlist-scroll-target" />
        </FlexBox>
        )
      }
    } , [finalistsProjects, showProjects, finalistsPagination.page, finalistsPagination.items, t])

    const nominationsView = useMemo(() => {
      if (nominationsLoading) {
        return (
          <ProjectsGridNew k={8} isLoading={true} itemType={ItemType.book} />
        )
      }
      if (nominatiosWinners?.length > 0 && queryTab === 'results') {
        return (
          <WinnerGapContainer>
            {nominatiosWinners?.map(({ projects, name, color }, index) => {
          return (
            <WinnerGapContainer>
              <NominationName name={name} color={color ?? Colors.galBlack100}/>
              <WinnersBox mobile={isMobile}>
                {projects.map((winnerProject) => {
                  return (
                    <WinnerProjectWrapper isLargeProject={calcGridColumn(winnerProject)} key={winnerProject.project.projectId}>
                      <WinnerPlace>
                        <WinnerText>{winnerProject.position ?? 1}</WinnerText>
                        <WinnerText>{t("competition.short_list.place")}</WinnerText>
                      </WinnerPlace>
                      <ProjectCardNew
                        project={winnerProject.project}
                        {...computeProject(winnerProject.project)}
                        itemType={calcGridColumn(winnerProject) ? ItemType.competition : ItemType.book}
                        isModal={false}
                        withoutGoToProject={false}
                        isSelectable={false}
                      />
                    </WinnerProjectWrapper>
                  );
                })}
              </WinnersBox>
            </WinnerGapContainer>
          )
        })
      }
          </WinnerGapContainer>
        )}
  } , [nominatiosWinners, nominationsLoading, competition,hasManyCompetitions])

    return (
      <ListOuter style={{ marginTop: isMobile ? 0 : "24px", padding: 0 }}>
        <FlexBox align="center" offsetTopMobile={10}>
          {searchBar}
        </FlexBox>
        {nominationsView}
        {winnersView}
        {finalistView}
      </ListOuter>
    )
};
